import { render } from "./FTSIndicatorTypeField.vue?vue&type=template&id=1f98c3b6&ts=true"
import script from "./FTSIndicatorTypeField.vue?vue&type=script&lang=ts"
export * from "./FTSIndicatorTypeField.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__